export default "__VITE_ASSET__DZSdgxua__"